import { ElementWithMeta } from '../../types';
import { FormControllerFieldMeta } from '../controllers';
import { getModelPathFromIndex } from './model/getModelPath';
import { InputModel } from './model/types';

export function addReadOnlyToMeta<Model = InputModel>(
  elements: ElementWithMeta<Model>[],
  fieldMeta: FormControllerFieldMeta = {}
) {
  const newFieldMeta = { ...fieldMeta };
  elements.forEach((el) => {
    if (el.params?.readonly) {
      el.fields.forEach((_, i) => {
        const path = getModelPathFromIndex(el, i, false);
        newFieldMeta[path] = { ...(fieldMeta[path] ?? {}), disabled: true };
      });
    }

    el.fields.forEach((field, i) => {
      if (field.readonly) {
        const path = getModelPathFromIndex(el, i, false);
        newFieldMeta[path] = { ...(fieldMeta[path] ?? {}), disabled: true };
      }
    });
  });
  return newFieldMeta;
}
